import BaseConfig from "./BaseConfig";

export default class ContactEmail extends BaseConfig {
  label() {
    return (
      this.customerInfo?.customerServiceEmail ||
      this.toAddressMap[this.commodityType]
    );
  }
}
